import { render, staticRenderFns } from "./questionPaper.vue?vue&type=template&id=49ff25aa&scoped=true"
import script from "./questionPaper.vue?vue&type=script&lang=js"
export * from "./questionPaper.vue?vue&type=script&lang=js"
import style0 from "./questionPaper.vue?vue&type=style&index=0&id=49ff25aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ff25aa",
  null
  
)

export default component.exports